import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "error-page" }
const _hoisted_2 = { class: "au-card error-card" }
const _hoisted_3 = { class: "error-title" }
const _hoisted_4 = { class: "error-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "au-tile is-indigo error-tile" }, [
        _createElementVNode("i", { class: "bi bi-signpost-split" })
      ], -1)),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "error-code error-code-indigo" }, "404", -1)),
      _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("errors.notFound.title")), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("errors.notFound.text")), 1),
      _createVNode(_component_router_link, {
        class: "btn btn-primary",
        to: { name: 'Dashboard' }
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "bi bi-house-door" }, null, -1)),
          _createTextVNode(_toDisplayString(_ctx.$t("errors.backToDashboard")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}